module.exports = __webpack_public_path__ + "static/media/tablet-01.94e50fd7.jpg";